export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;
export const API_PHP = import.meta.env.VITE_API_PHP;
export const IS_PRODUCTION = import.meta.env.PROD;
export const FE_CLEVAI_ADMIN_HOST = import.meta.env.VITE_FE_CLEVAI_ADMIN_HOST;
export const URL = import.meta.env.VITE_URL;
export const ACTIVITY_LOG_URL = import.meta.env.VITE_ACTIVITY_LOG_URL;
export const TEACHER_HOST = import.meta.env.VITE_TEACHER_HOST;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
// Autogen CTI ver 2 — host of the crps-autogen app, mounted as a same-origin MFE in the Autogen CTI tab.
// Empty ⇒ the tab renders a placeholder instead of a broken mount.
export const AUTOGEN_CTI_HOST = import.meta.env.VITE_AUTOGEN_CTI_HOST || "";
